import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { LensContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { LensCard } from '../../../app/spaces/CardView/LensCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { Lenses } from '../../resources/Lenses';
import { IContentInfo } from '../IContentInfo';
import { call } from 'redux-saga/effects';
import { getLensInfos } from '../../../app/sagas/spaces/SpacesSagaHelpers';

export const LensDefinition: MixedContentItemDefinition & SpaceDefinition<'lens'> = {
  itemType: 'lens',
  contentType: 'lens',
  singularName: Messages.lens,
  pluralName: Messages.lenses,
  emptyStateMessage: Messages.lensesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Lenses,
  // TODO: use the sharedURL lensUrl here once that is merged in shared-urls repo.
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => '/lens/' + contentId,
  contentFilterKeys: LensContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: LensCard,
  listViewIconUrl: imgPath('spaces_medium_ds.svg'),
  filterClause: ServerFilterClauses.ContentType(['lens']) as ContentTypeFilterClause,
  getBasicQuery: () => Lenses.all(),
  fieldValueResourceType: 'lens',
  getContentInfo: (contentList: IContentInfo[]) => call(getLensInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_datarole.svg'),
};
